module.exports = __webpack_public_path__ + "img/blue-arrow.20171ff1.svg";